import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import updateUserConfiguration from 'owa-session-store/lib/services/updateUserConfiguration';

export default function updateSendAsMruAddresses(sendAsMruAddresses: string[]) {
    updateUserConfiguration('OWA.UserOptions', [
        userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: ['SendAsMruAddresses'],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: 'StringArray',
                Value: sendAsMruAddresses,
            }),
        }),
    ]);
}
